import _ from 'lodash';

/**
 * Returns a plain, Redux-serializable error object for RTK Query queryFn/mutationFn.
 */
export const serializeRtkQueryError = error => {
  if (error == null) {
    return { Message: 'Unknown error' };
  }

  if (typeof error !== 'object') {
    return { Message: String(error) };
  }

  const body =
    error.response?.body ??
    (typeof error.response?.text === 'string'
      ? (() => {
          try {
            return JSON.parse(error.response.text);
          } catch {
            return null;
          }
        })()
      : null);

  const apiError =
    body && typeof body === 'object'
      ? body
      : _.pick(error, [
          'Success',
          'Code',
          'Message',
          'Text',
          'Data',
          'failedHttpMethod',
          'failedHttpUrl',
          'failedHttpRequestBodyFull'
        ]);

  if (apiError.Code || apiError.Message || apiError.Success === false) {
    return apiError;
  }

  return {
    Message: error.message || error.Message || 'Request failed',
    ...(error.Code ? { Code: error.Code } : {}),
    ...(error.statusCode ? { statusCode: error.statusCode } : {}),
    ...(error.status ? { statusCode: error.status } : {})
  };
};
